import React, { Component } from 'react';

import {
  Bar,
  BarChart,
  ResponsiveContainer,
  LabelList,
  XAxis,
  YAxis,
} from 'recharts';

class InlineGraph extends Component {
  render() {
    return (

      <ResponsiveContainer width='100%' height={25}>
        <BarChart
          data={[{ bar: this.props.value }]}
          layout="vertical"
          margin={{ top: 0, left: 0, right: 50, bottom: 0 }}
        >
          <XAxis
            type="number"
            hide
            domain={[0, Math.max(...this.props.routes.map(e => e.realdist))]}
          />
          <YAxis type="category" dataKey="bar" hide />
          <Bar dataKey="bar" fill="#79508f" isAnimationActive={false}>
            <LabelList
              dataKey="bar"
              position="right"
              fill="black"
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>

    );
  }
}

export default InlineGraph;